// extracted by mini-css-extract-plugin
export default {"form":"TimerInput_form__IILEJ","timeMenu":"TimerInput_timeMenu__ef0LG","inputContainer":"TimerInput_inputContainer__Us06z"};